'use client';

import { useEffect, useState } from 'react';
import { useAppStore } from '@/store/app';

/**
 * 断网提示 + 自动重连（v0.8 体验强化包）：
 * 断线时顶部悬浮提示条；恢复后派发 `ailumix:online` 事件，
 * 供页面数据组件监听重连（TanStack Query 默认 refetchOnReconnect
 * 也会自动触发后台 refetch），避免白屏无反馈。
 */
export default function NetworkStatus() {
  const { language } = useAppStore();
  const zh = language !== 'en';
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // 初始状态：若已离线则立即显示
    setOffline(!navigator.onLine);
    const on = () => {
      setOffline(false);
      window.dispatchEvent(new Event('ailumix:online'));
    };
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="fixed left-1/2 top-3 z-[98] -translate-x-1/2">
      <div className="flex items-center gap-2 rounded-full border border-gf-warn/40 bg-gf-surface2/95 px-4 py-1.5 shadow-2xl backdrop-blur">
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-gf-warn" />
        <span className="text-xs font-medium text-gf-warn">
          {zh ? '网络已断开，恢复后自动重连' : 'Offline — reconnecting automatically'}
        </span>
      </div>
    </div>
  );
}
